/*
 * @Author: manuelzhao manuelzhao@tencent.com
 * @Date: 2022-09-30 12:27:56
 * @LastEditors: manuelzhao manuelzhao@tencent.com
 * @LastEditTime: 2022-11-07 11:41:56
 * @FilePath: /wemeet-web-activity/src/lib/http/get-req-config.ts
 * @Description: 服务端的不需要走sessionStorage
 */
import { AxiosRequestConfig } from 'axios';
import { GetServerSidePropsContext } from 'next';
import cookies from 'next-cookies';
import getNextUserAgent from '@utils/ua/get-user-agent';
import getInstanceId from '@utils/ua/get-instance-id';
import getAppVersion from '@utils/ua/get-app-version';
import isServer from '@utils/env/is-server';
import { isWeMeetApp } from '@tencent/web-base';
import { NextRequest } from 'next/server';
import { getUserInfoFromSession } from '@utils/login-util';

// eslint-disable-next-line complexity
export async function getReqConfig(
  ctx: GetServerSidePropsContext | undefined,
  req: NextRequest | undefined,
  clearTdeCookie?: boolean,
) {
  const userAgent = getNextUserAgent(ctx, req);
  const allCookies = cookies(ctx || {});
  const instanceId = getInstanceId(userAgent);
  // console.log('getReqConfig', allCookies);
  let cToken = allCookies.ticket || allCookies.we_meet_token || req?.cookies?.we_meet_token || '';
  if (isServer) {
    console.log('next userAgent:', `[${allCookies.app_uid}]`, userAgent);
  } else {
    cToken = window.currentTicket || cToken;
  }

  let appId =
    allCookies.corp_id ||
    allCookies.app_id ||
    ctx?.query.app_id ||
    req?.cookies?.corp_id ||
    req?.cookies?.app_id ||
    '';
  let appUid = allCookies.app_uid || ctx?.query.app_uid || req?.cookies?.app_uid || '';
  const lang = ctx?.query.lang || 'zh-CN';
  if (!appUid && typeof wemeet !== 'undefined') {
    const { data } = wemeet;
    const userInfo = await data.getUserInfo();
    if (userInfo) {
      appId = userInfo.appId;
      appUid = userInfo.appUid;
    }
  }
  if (!appUid && !ctx) {
    const userInfo = getUserInfoFromSession();
    appId = userInfo?.crop_id || userInfo?.app_id || '';
    appUid = userInfo?.userid || userInfo?.app_uid || '';
  }
  // 公共参数
  const queryParams = {
    c_instance_id: '5',
    c_os: 'web',
    c_os_model: 'web',
    c_os_version: encodeURIComponent(userAgent),
    c_nonce: new Date().getTime(),
    c_timestamp: new Date().getTime(),
    c_app_id: appId,
    c_app_uid: appUid,
    c_platform: isWeMeetApp(userAgent) ? '5' : '0', // 本地开发时，使用0，端上用5
    c_token: cToken,
    c_app_version:
      allCookies.app_version || req?.cookies?.app_version || getAppVersion(userAgent) || '',
    platform: instanceId.name || 'web',
    app_id: appId,
    c_lang: lang,
  };

  const config: AxiosRequestConfig = {
    params: queryParams,
  };
  if (isServer) {
    let cookies = ctx?.req?.headers.cookie || req?.headers?.get('Cookie') || '';
    const pathUrl = ctx?.req?.url || '';
    const referer = ctx?.req?.headers.referer || '';
    // TDE预发set环境要走线上请求的，先删掉tde的cookie吧
    if (clearTdeCookie && cookies) {
      cookies = cookies.replace('tde_proxy=', '');
    }
    config.headers = {
      Cookie: cookies,
      Referer: referer || `https://meeting.tencent.com${pathUrl}`,
      'app-uid': appUid,
      'app-id': appId,
    };
  }
  return config;
}
